var _AxisPlacement$BOTH, _AxisPlacement$BOTTOM, _AxisPlacement$TOP, _XY_GRIDS;

import React from 'react';
import PropTypes from 'prop-types';
import AxisPlacement from '../AxisPlacement';
import GriffPropTypes from '../../utils/proptypes';

var propTypes = {
  contextChart: PropTypes.node,
  lineChart: PropTypes.node.isRequired,
  xAxis: PropTypes.node.isRequired,
  xAxisPlacement: GriffPropTypes.axisPlacement,
  yAxis: PropTypes.node.isRequired,
  yAxisPlacement: GriffPropTypes.axisPlacement
};

var defaultProps = {
  xAxisPlacement: AxisPlacement.BOTTOM,
  yAxisPlacement: AxisPlacement.RIGHT,
  contextChart: null
};

var xAxisContainer = function xAxisContainer(area) {
  return function (axis, placement) {
    return React.createElement(
      'div',
      {
        key: area,
        className: 'x-axis-container',
        style: {
          gridArea: area,
          display: 'flex',
          flexDirection: 'row',
          width: '100%'
        }
      },
      React.cloneElement(axis, { xAxisPlacement: placement })
    );
  };
};

var yAxisContainer = function yAxisContainer(area) {
  return function (axis, placement) {
    return React.createElement(
      'div',
      {
        key: area,
        className: 'y-axis-container',
        style: {
          gridArea: area,
          display: 'flex',
          flexDirection: 'column'
        }
      },
      React.cloneElement(axis, { yAxisPlacement: placement })
    );
  };
};

var XY_GRIDS = (_XY_GRIDS = {}, _XY_GRIDS[AxisPlacement.BOTH] = (_AxisPlacement$BOTH = {}, _AxisPlacement$BOTH[AxisPlacement.BOTH] = [
// formatting for readability
'. xaxis-top .', 'yaxis-left chart yaxis-right', '. xaxis-bottom .', '. context .'], _AxisPlacement$BOTH[AxisPlacement.LEFT] = [
// formatting for readability
'. xaxis-top', 'yaxis chart', '. xaxis-bottom', '. context'], _AxisPlacement$BOTH[AxisPlacement.RIGHT] = [
// formatting for readability
'xaxis-top .', 'chart yaxis', 'xaxis-bottom .', 'context .'], _AxisPlacement$BOTH), _XY_GRIDS[AxisPlacement.BOTTOM] = (_AxisPlacement$BOTTOM = {}, _AxisPlacement$BOTTOM[AxisPlacement.BOTH] = [
// formatting for readability
'yaxis-left chart yaxis-right', '. xaxis .', '. context .'], _AxisPlacement$BOTTOM[AxisPlacement.LEFT] = [
// formatting for readability
'yaxis chart', '. xaxis', '. context'], _AxisPlacement$BOTTOM[AxisPlacement.RIGHT] = [
// formatting for readability
'chart yaxis', 'xaxis .', 'context .'], _AxisPlacement$BOTTOM), _XY_GRIDS[AxisPlacement.TOP] = (_AxisPlacement$TOP = {}, _AxisPlacement$TOP[AxisPlacement.BOTH] = [
// formatting for readability
'. xaxis .', 'yaxis-left chart yaxis-right', '. context .'], _AxisPlacement$TOP[AxisPlacement.LEFT] = [
// formatting for readability
'. xaxis', 'yaxis chart', '. context'], _AxisPlacement$TOP[AxisPlacement.RIGHT] = [
// formatting for readability
'xaxis .', 'chart yaxis', 'context .'], _AxisPlacement$TOP), _XY_GRIDS);

var Layout = function Layout(_ref) {
  var contextChart = _ref.contextChart,
      lineChart = _ref.lineChart,
      xAxis = _ref.xAxis,
      xAxisPlacement = _ref.xAxisPlacement,
      yAxis = _ref.yAxis,
      yAxisPlacement = _ref.yAxisPlacement;

  var xAxes = [];
  var yAxes = [];
  var areas = (XY_GRIDS[xAxisPlacement][yAxisPlacement] || XY_GRIDS[AxisPlacement.BOTTOM][AxisPlacement.RIGHT]).map(function (s) {
    return '\'' + s + '\'';
  }).join(' ');

  switch (yAxisPlacement) {
    case AxisPlacement.BOTH:
      {
        yAxes.push(yAxisContainer('yaxis-left')(yAxis, AxisPlacement.LEFT));
        yAxes.push(yAxisContainer('yaxis-right')(yAxis, AxisPlacement.RIGHT));
        break;
      }
    case AxisPlacement.LEFT:
    case AxisPlacement.RIGHT:
    case AxisPlacement.UNSPECIFIED:
    default:
      yAxes.push(yAxisContainer('yaxis')(yAxis, yAxisPlacement));
      break;
  }

  switch (xAxisPlacement) {
    case AxisPlacement.BOTH:
      {
        xAxes.push(xAxisContainer('xaxis-top')(xAxis, AxisPlacement.TOP));
        xAxes.push(xAxisContainer('xaxis-bottom')(xAxis, AxisPlacement.BOTTOM));
        break;
      }
    case AxisPlacement.TOP:
    case AxisPlacement.BOTTOM:
    case AxisPlacement.UNSPECIFIED:
    default:
      xAxes.push(xAxisContainer('xaxis')(xAxis, xAxisPlacement));
      break;
  }

  return React.createElement(
    'div',
    {
      className: 'linechart-container',
      style: {
        display: 'grid',
        gridTemplateAreas: areas,
        height: '100%'
      }
    },
    React.createElement(
      'div',
      {
        className: 'lines-container',
        style: { gridArea: 'chart', height: '100%' }
      },
      lineChart
    ),
    yAxes,
    xAxes,
    React.createElement('div', { style: { gridArea: 'spacer' } }),
    contextChart && React.createElement(
      'div',
      {
        className: 'context-container',
        style: {
          gridArea: 'context',
          display: 'flex',
          flexDirection: 'column'
        }
      },
      contextChart
    )
  );
};

Layout.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
Layout.defaultProps = defaultProps;

export default Layout;